import CustomBootstrapInlineTableAsync from "./CustomBootstrapInlineTableAsync"
import CustomBootstrapInlineTable from "./CustomBootstrapInlineTable"

const CustomBootstrapTableWrapper = ({ isScrollable, ...rest }) => {
  if (!isScrollable) return <CustomBootstrapInlineTableAsync {...rest} />
  else return <CustomBootstrapInlineTable isScrollable {...rest} />
}

export default CustomBootstrapTableWrapper
